import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useGlobalValue } from "../utils/GlobalState";
import { setErrors } from "../utils/Actions";

export default function ErrorModal() {
  const [{ errors }, dispatch] = useGlobalValue();

  if (Object.prototype.toString.call(errors) === "[object Error]") {
    setErrors([errors.toString()], dispatch);
    return <></>;
  }

  return (
    <Modal show={errors.length > 0} onHide={() => {}}>
      <Modal.Header>
        <Modal.Title>An Error Occurred</Modal.Title>
      </Modal.Header>

      <Modal.Body className="alert-danger" style={{ padding: "20px" }}>
        <ul>
          {errors.map(error => {
            return <li key={error}>{error}</li>;
          })}
        </ul>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="success" onClick={() => setErrors([], dispatch)}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
